import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=b493bbee&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b493bbee')) {
      api.createRecord('b493bbee', component.options)
    } else {
      api.reload('b493bbee', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=b493bbee&", function () {
      api.rerender('b493bbee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b8DZu5Fk4WE6/JS/imageCarousel.vue"
export default component.exports